$(document).ready(function() {
    
    // ✅ INJECT MODAL CSS
    const modalCSS = `
    <style id="pre-order-modal-styles">
        .core-color-modal {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
            z-index: 9999;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(4px);
            opacity: 0;
            transition: opacity 0.3s ease;
        }
        .core-color-modal.active {
            display: flex !important;
            opacity: 1;
        }
        .core-modal-content {
            background: white;
            border-radius: 16px;
            padding: 40px;
            max-width: 500px;
            width: 90%;
            position: relative;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }
        .core-modal-close {
            position: absolute;
            top: 16px;
            right: 16px;
            background: none;
            border: none;
            font-size: 28px;
            cursor: pointer;
            color: #666;
            width: 38px;
            height: 38px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: background-color 0.2s ease;
        }
        .core-modal-close:hover {
            background-color: #f0f0f0;
        }
        .core-modal-title {
            font-size: 24px;
            font-weight: 700;
            color: #121212;
            margin: 0 0 12px;
        }
        .core-modal-description {
            font-size: 16px;
            color: #666;
            margin: 0 0 24px;
        }
        .core-modal-color-display {
            background: #fff5eb;
            border-radius: 8px;
            padding: 15px 20px;
            margin-bottom: 24px;
            text-align: center;
        }
        .core-modal-color-display span {
            color: #ff9933;
            font-size: 18px;
            font-weight: 600;
        }
        .core-modal-form {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }
        .core-modal-input {
            width: 100%;
            padding: 14px 18px;
            font-size: 16px;
            border: 2px solid #e0e0e0;
            border-radius: 8px;
            box-sizing: border-box;
        }
        .core-modal-input:focus {
            outline: none;
            border-color: #ff8c42;
        }
        .core-modal-submit {
            padding: 14px 28px;
            background-color: #ff8c42;
            color: white;
            border: none;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.2s ease;
        }
        .core-modal-submit:hover {
            background-color: #ff7a29;
        }
        .core-modal-submit:disabled {
            background-color: #ccc;
            cursor: not-allowed;
        }
        .core-modal-success {
            display: none;
            text-align: center;
            padding: 20px;
        }
        .core-modal-success.active {
            display: block !important;
        }
        .core-modal-success-icon {
            width: 60px;
            height: 60px;
            margin: 0 auto 20px;
            color: #4caf50;
        }
        .core-modal-success-message {
            font-size: 18px;
            color: #121212;
            font-weight: 600;
        }
        .core-modal-note {
            font-size: 12px;
            color: #999;
            text-align: center;
            margin-top: 20px;
        }
        @media screen and (max-width: 768px) {
            .core-modal-content {
                padding: 30px 24px;
            }
            .core-modal-title {
                font-size: 20px;
            }
        }
    </style>
    `;

    // ✅ INJECT MODAL HTML
    const modalHTML = `
    <div class="core-color-modal" data-core-modal style="display: none;">
        <div class="core-modal-content">
            <button class="core-modal-close" data-core-modal-close aria-label="Close modal">
                &times;
            </button>
            
            <div data-core-modal-form-container>
                <h3 class="core-modal-title">Join Our Waitlist</h3>
                <p class="core-modal-description">Be the first to know when we launch your custom design!</p>
                
                <div class="core-modal-color-display" data-core-color-display>
                    <span data-core-color-name>Custom Stethoscope</span>
                </div>
                
                <form class="core-modal-form" data-core-email-form action="/contact#core-newsletter" method="post" accept-charset="UTF-8">
                    <input type="hidden" name="form_type" value="customer">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="contact[tags]" value="newsletter,waitlist,pre-order,custom-stethoscope" data-core-base-tags>
                    <input type="hidden" name="contact[note][Customization Details:]" value="" data-core-color-hidden>
                    
                    <input
                        type="email"
                        name="contact[email]"
                        class="core-modal-input"
                        placeholder="Enter your email address"
                        required
                        data-core-email-input
                    >
                    
                    <input
                        type="text"
                        name="contact[note][Model Details:]"
                        class="core-modal-input"
                        placeholder="Additional notes (optional)"
                        data-core-model-input
                    >
                    
                    <button type="submit" class="core-modal-submit" data-core-submit-btn>
                        Join Waitlist
                    </button>
                </form>

                <p class="core-modal-note">We'll notify you when your custom design is ready!</p>
            </div>

            <div class="core-modal-success" data-core-success-message style="display: none;">
                <svg class="core-modal-success-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <p class="core-modal-success-message">You're on the list! We'll notify you soon.</p>
            </div>
        </div>
    </div>
    `;

    // ✅ Inject CSS and HTML into page
    if (!$('#pre-order-modal-styles').length) {
        $('head').append(modalCSS);
    }
    if (!$('[data-core-modal]').length) {
        $('body').append(modalHTML);
    }

    console.log('✅ Modal injected successfully');

    // step 2 check for step 3 start
    let selectedTab = '';

    $('#myTab a.nav-link').on('shown.bs.tab', function (e) {
        selectedTab = $(e.target).text().trim();
    });

    $('#next-btn').on('click', function () {
        console.log('Step 2 Selected Option:', selectedTab);
    });

    // Pricing configuration
    const stepPrices = {
        1: 15,
        2: 15,
        3: 15,
        4: 4
    };
    
    let totalPrice = 0;
    let selectedStepPrices = {};
    let currentStep = 1;
    let selectedOptions = {};
    let allSelections = {};
    let step1SelectedIndex = 0;
    let step2SelectedIndex = 0;
    let step3SelectedIndex = 0;
    let finalCustomizedImageUrl = '';

    const priceVariants = {
        15: '45364352876740',
        30: '45364352909508',
        45: '45364352942276',
        49: '45364352975044'
    };

    function getVariantIdByPrice(totalPrice) {
        const prices = Object.keys(priceVariants).map(p => parseInt(p)).sort((a, b) => a - b);
        
        for (let i = 0; i < prices.length; i++) {
            if (totalPrice <= prices[i]) {
                return priceVariants[prices[i]];
            }
        }
        return priceVariants[prices[prices.length - 1]];
    }

    function updatePricing() {
        const currentStepPrice = stepPrices[currentStep] || 0;
        $('#current-step-price').text(currentStepPrice);
        
        totalPrice = Object.values(selectedStepPrices).reduce((sum, price) => sum + price, 0);
        $('#total-price').text(totalPrice);
    }

    function addStepPrice(step) {
        if (stepPrices[step]) {
            selectedStepPrices[step] = stepPrices[step];
            updatePricing();
        }
    }

    function removeStepPrice(step) {
        if (selectedStepPrices[step]) {
            delete selectedStepPrices[step];
            updatePricing();
        }
    }

    function changeStethoscopeImage(imageUrl) {
        const mainImage = $('#main-stethoscope-image');
        const container = $('.stethoscope-image');

        finalCustomizedImageUrl = imageUrl;
        console.log('Final image URL stored:', finalCustomizedImageUrl);

        container.addClass('loading');

        const newImg = new Image();

        newImg.onload = function() {
            container.removeClass('loading');
            mainImage.addClass('fade-out');

            setTimeout(() => {
                mainImage.attr('src', imageUrl);
                mainImage.removeClass('fade-out').addClass('fade-in');

                setTimeout(() => {
                    mainImage.removeClass('fade-in');
                }, 500);
            }, 250);
        };

        newImg.onerror = function() {
            container.removeClass('loading');
            console.log('Failed to load image:', imageUrl);
        };

        newImg.src = imageUrl;
    }

    function updateStep(step) {
        const currentStepElement = $('#step-' + currentStep);
        const radioGroups = currentStepElement.find('input[type="radio"]');

        radioGroups.each(function() {
            if ($(this).prop('checked')) {
                if (!selectedOptions[currentStep]) {
                    selectedOptions[currentStep] = {};
                }
                selectedOptions[currentStep][$(this).attr('name')] = $(this).val();
            }
        });

        allSelections = $.extend({}, allSelections, selectedOptions[currentStep]);
        console.log(allSelections);
        updatePricing();

        $('.step').hide();
        $('#step-' + step).show();
        $('.step-navigation .step-number').text('Step ' + step);
        
        if (step === 5) {
            updateFinalStepDisplay();
            if (finalCustomizedImageUrl) {
                console.log('Showing final image in step 5:', finalCustomizedImageUrl);
                setTimeout(() => {
                    changeStethoscopeImage(finalCustomizedImageUrl);
                }, 100);
            }
        }

        if (step > currentStep) {
            $('#step-' + step + ' input[type="radio"]').prop('checked', false);
        } else if (step < currentStep && selectedOptions[step]) {
            $.each(selectedOptions[step], function(name, value) {
                const radioToCheck = $('#step-' + step + ' input[name="' + name + '"][value="' + value + '"]');
                if (radioToCheck.length) {
                    radioToCheck.prop('checked', true);
                }
            });
        }

        currentStep = step;
        if (step === 1) {
            $('#prev-btn').hide();
        } else {
            $('#prev-btn').show();
        }

        if (step === 5) {
            $('#next-btn').hide();
            $('#submit-btn').show();
        } else {
            $('#next-btn').show();
            $('#submit-btn').hide();
        }

        checkRadioSelection();
    }

    function checkRadioSelection() {
        const currentStepElement = $('#step-' + currentStep);
        let hasSelection = false;

        const radioGroups = currentStepElement.find('input[type="radio"]');
        const radioNames = new Set();

        radioGroups.each(function() {
            radioNames.add($(this).attr('name'));
        });

        radioNames.forEach(function(name) {
            if (currentStepElement.find('input[name="' + name + '"]:checked').length) {
                hasSelection = true;
            }
        });

        const nextBtn = $('#next-btn');
        if (nextBtn.length) {
            nextBtn.prop('disabled', !hasSelection);
            if (nextBtn.prop('disabled')) {
                nextBtn.css({
                    background: 'transparent',
                    border: '1px solid #A0A0A0',
                    color: '#A0A0A0'
                });
            } else {
                nextBtn.css({
                    background: '#EC9526',
                    border: 'none',
                    color: '#FFF'
                });
            }
        }
    }

    function updateSubmitButtonText() {
        let hasCoreSelection = false;

        $('.step').each(function() {
            const step = $(this);
            if (step.find('.core-tab input[type="radio"]:checked').length > 0) {
                hasCoreSelection = true;
            }
        });

        $('#submit-btn').text(hasCoreSelection ? 'Pre-Order' : 'Get My Complete Look');
    }

    function updateFinishNameText() {
        const selectedFinish = $('input[name="finish"]:checked');
        if (selectedFinish.length > 0) {
            const finishTitle = selectedFinish.data('title');
            $('#selected-finish-name').text(`"${finishTitle}"`);
            showRelevantSuggestions(finishTitle);
        }
    }

    function showRelevantSuggestions(finishTitle) {
        $('#pairing-cards .pairing-card').each(function() {
            const pairing = $(this).data('pairing');
            if (pairing === finishTitle) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    }

    function buildDesignSummary() {
        const getDisplayName = (value, type) => {
            if (!value) return 'Not selected';
            
            switch(type) {
                case 'finish': return value.replace('-bg', '');
                case 'pipe': return value.replace('-pipe', '');
                case 'ring': return value.replace('-ring', '');
                case 'earpiece': return value.replace('-earpiece', '');
                default: return value;
            }
        };

        const chestpiece = getDisplayName(allSelections.finish, 'finish');
        const tubing = getDisplayName(allSelections['finish-pipe'], 'pipe');
        const ring = getDisplayName(allSelections['finish-ring'], 'ring');
        const earpiece = getDisplayName(allSelections['earpiece-color'], 'earpiece');

        const title = `Custom Stethoscope - $59`;
        const details = `Chestpiece: ${chestpiece} | Tubing: ${tubing} | Ring: ${ring} | Earpiece: ${earpiece} | Total: $${totalPrice}`;
        const shortSummary = `${chestpiece} / ${tubing} / ${ring} / ${earpiece}`;

        return {
            title: title,
            details: details,
            shortSummary: shortSummary,
            imageUrl: finalCustomizedImageUrl
        };
    }

    function openPreOrderModal() {
        const modal = document.querySelector('[data-core-modal]');
        
        if (!modal) {
            console.error('❌ Modal not found in DOM!');
            alert('Modal not found. Please refresh the page and try again.');
            return;
        }

        const colorNameDisplay = modal.querySelector('[data-core-color-name]');
        const colorHiddenInput = modal.querySelector('[data-core-color-hidden]');
        const baseTagsInput = modal.querySelector('[data-core-base-tags]');
        const modelInput = modal.querySelector('[data-core-model-input]');
        
        const designSummary = buildDesignSummary();
        
        console.log('🎯 Opening Pre-Order Modal with:', designSummary);
        
        if (colorNameDisplay) {
            colorNameDisplay.textContent = designSummary.title;
        }
        
        if (colorHiddenInput) {
            colorHiddenInput.value = designSummary.details;
        }
        
        if (baseTagsInput) {
            baseTagsInput.value = 'newsletter,waitlist,pre-order,custom-stethoscope';
        }
        
        if (modelInput) {
            modelInput.value = designSummary.shortSummary;
        }
        
        let imageField = modal.querySelector('[data-custom-image]');
        if (!imageField) {
            imageField = document.createElement('input');
            imageField.type = 'hidden';
            imageField.name = 'contact[note][Custom Image URL:]';
            imageField.setAttribute('data-custom-image', '');
            const form = modal.querySelector('[data-core-email-form]');
            if (form) {
                form.appendChild(imageField);
            }
        }
        if (imageField) {
            imageField.value = finalCustomizedImageUrl;
        }
        
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        
        console.log('✅ Pre-Order Modal opened successfully');
    }

    
// async function proceedToCheckout(checkoutData) {
//     try {
//         $('#submit-btn').prop('disabled', true).text('Processing...');

//         // ✅ Hardcoded variant IDs use karo - no product fetch needed
//         const variantId = getVariantIdByPrice(checkoutData.totalPrice);
//         console.log(`✅ Using variant ID: ${variantId} for $${checkoutData.totalPrice}`);

//         const properties = {};
//         if (allSelections.finish) {
//             properties['Chestpiece'] = allSelections.finish.replace('-bg', '');
//         }
//         if (allSelections['finish-pipe']) {
//             properties['Tubing'] = allSelections['finish-pipe'].replace('-pipe', '');
//         }
//         if (allSelections['finish-ring']) {
//             properties['Ring'] = allSelections['finish-ring'].replace('-ring', '');
//         }
//         if (allSelections['earpiece-color']) {
//             properties['Earpiece'] = allSelections['earpiece-color'].replace('-earpiece', '');
//         }
//         if (finalCustomizedImageUrl) {
//             properties['🖼️ View Design'] = finalCustomizedImageUrl;
//         }

//         const cartData = {
//             items: [{
//                 id: variantId,
//                 quantity: 1,
//                 properties: properties
//             }]
//         };

//         const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/json'
//             },
//             body: JSON.stringify(cartData)
//         });

//         if (response.ok) {
//             console.log('✅ Added to cart!');
//             window.location.href = '/cart';
//         } else {
//             const errorText = await response.text();
//             console.error('❌ Cart add failed:', response.status, errorText);
//             throw new Error('Failed to add to cart');
//         }

//     } catch (error) {
//         console.error('❌ Error:', error);
//         alert('Sorry, there was an error. Please try again or contact support.');
//     } finally {
//         setTimeout(() => {
//             $('#submit-btn').prop('disabled', false);
//             updateSubmitButtonText();
//         }, 2000);
//     }
// }

async function proceedToCheckout() {
    try {
        $('#submit-btn')
            .prop('disabled', true)
            .text('Processing...');

        const productHandle = 'classic-iii-custom-starter-set';

        const response = await fetch(`/products/${productHandle}.js`);
        const productData = await response.json();

        // ================================
        // SELECTED COLORS SE VARIANT MATCH
        // ================================

        const pipe = (allSelections['finish-pipe'] || '')
            .replace('-pipe', '').trim().toLowerCase();

        const ring = (allSelections['finish-ring'] || '')
            .replace('-ring', '').trim().toLowerCase();

        const earpiece = (allSelections['earpiece-color'] || '')
            .replace('-earpiece', '').trim().toLowerCase();

        console.log('PIPE:', pipe, '| RING:', ring, '| EARPIECE:', earpiece);

        const selectedVariant = productData.variants.find(v => {
            const opts = v.options.map(o => (o || '').trim().toLowerCase());
            return opts[0] === pipe && opts[1] === ring && opts[2] === earpiece;
        });

        if (!selectedVariant) {
            alert('This combination is not available. Please try a different one.');
            $('#submit-btn').prop('disabled', false);
            updateSubmitButtonText();
            return;
        }

        console.log(`✅ VARIANT: ${selectedVariant.title} | ID: ${selectedVariant.id}`);

        // ================================
        // PROPERTIES
        // ================================

        const properties = {
            Finish: (allSelections.finish || '').replace('-bg', ''),
            Pipe: (allSelections['finish-pipe'] || '').replace('-pipe', ''),
            Ring: (allSelections['finish-ring'] || '').replace('-ring', ''),
            Earpiece: (allSelections['earpiece-color'] || '').replace('-earpiece', '')
        };

        if (finalCustomizedImageUrl) {
            properties['🖼️ Design'] = finalCustomizedImageUrl;
        }

        const cartData = {
            items: [{ id: selectedVariant.id, quantity: 1, properties }]
        };

        const cartResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(cartData)
        });

        if (!cartResponse.ok) {
            const err = await cartResponse.text();
            throw new Error(err);
        }

        window.location.href = '/cart';

    } catch (error) {
        console.error('❌ Checkout Error:', error);
        alert('Something went wrong. Please try again.');
    } finally {
        $('#submit-btn').prop('disabled', false);
        updateSubmitButtonText();
    }
}


// async function proceedToCheckout() {
//     try {
//         $('#submit-btn').prop('disabled', true).text('Processing...');

//         const productHandle = 'classic-iii-custom-starter-set';
//         const response = await fetch(`/products/${productHandle}.js`);
//         const productData = await response.json();

//         const pipe     = (allSelections['finish-pipe']    || '').replace('-pipe',     '').trim().toLowerCase();
//         const ring     = (allSelections['finish-ring']    || '').replace('-ring',     '').trim().toLowerCase();
//         const earpiece = (allSelections['earpiece-color'] || '').replace('-earpiece', '').trim().toLowerCase();

//         const selectedVariant = productData.variants.find(v => {
//             const opts = v.options.map(o => (o || '').trim().toLowerCase());
//             return opts[0] === pipe && opts[1] === ring && opts[2] === earpiece;
//         });

//         if (!selectedVariant) {
//             alert('This combination is not available. Please try a different one.');
//             $('#submit-btn').prop('disabled', false);
//             updateSubmitButtonText();
//             return;
//         }

//         const properties = {
//             Finish:   (allSelections.finish            || '').replace('-bg',       ''),
//             Pipe:     (allSelections['finish-pipe']    || '').replace('-pipe',     ''),
//             Ring:     (allSelections['finish-ring']    || '').replace('-ring',     ''),
//             Earpiece: (allSelections['earpiece-color'] || '').replace('-earpiece', '')
//         };

//         if (finalCustomizedImageUrl) {
//             properties['🖼️ Design'] = finalCustomizedImageUrl;
//         }

//         await fetch('/cart/clear.js', { method: 'POST' });

//         const cartResponse = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//             body: JSON.stringify({
//                 items: [{ id: selectedVariant.id, quantity: 1, properties }]
//             })
//         });

//         if (!cartResponse.ok) throw new Error(await cartResponse.text());

//         // ================================
//         // DIRECT CHECKOUT PERMALINK
//         // Variant ID + Discount embedded
//         // ================================
//         const discountCode = 'Customizer';
//         const checkoutUrl = `/cart/${selectedVariant.id}:1?discount=${discountCode}`;
//         window.location.href = checkoutUrl;

//     } catch (error) {
//         console.error('❌ Checkout Error:', error);
//         alert('Something went wrong. Please try again.');
//     } finally {
//         $('#submit-btn').prop('disabled', false);
//         updateSubmitButtonText();
//     }
// }

    function updateFinalStepDisplay() {
        const getDisplayName = (value, type) => {
            if (!value) return 'Not selected';
            
            switch(type) {
                case 'finish': return value.replace('-bg', '');
                case 'pipe': return value.replace('-pipe', '');
                case 'ring': return value.replace('-ring', '');
                case 'earpiece': return value.replace('-earpiece', '');
                default: return value;
            }
        };

        const pairingCards = $('#step-5 .pairing-cards');
        pairingCards.empty();

        const getSelectionColor = (type) => {
            const colors = {
                finish: { bg: '#000', border: '#E98A97' },
                pipe: { bg: '#000', border: '#B6CDA6' },
                ring: { bg: '#000', border: '#E8A539' },
                earpiece: { bg: '#000', border: '#E0C6D2' }
            };
            return colors[type] || { bg: '#999', border: '#CCC' };
        };

        if (allSelections.finish) {
            const color = getSelectionColor('finish');
            const finishCard = `
                <div class="pairing-card new-step">
                    <div class="main-text"><h2>Chestpiece Finish</h2></div>
                    <div class="main-box">
                        <div class="dot-text">
                            <strong style="color:${color.bg};">${getDisplayName(allSelections.finish, 'finish')}</strong>
                            <div class="desc">Your selected chestpiece finish</div>
                        </div>
                    </div>
                </div>
            `;
            pairingCards.append(finishCard);
        }

        if (allSelections['finish-pipe']) {
            const color = getSelectionColor('pipe');
            const tubingCard = `
                <div class="pairing-card new-step">
                    <div class="main-text"><h2>Tubing Color</h2></div>
                    <div class="main-box">
                        <div class="dot-text">
                            <strong style="color:${color.bg};">${getDisplayName(allSelections['finish-pipe'], 'pipe')}</strong>
                            <div class="desc">Your selected tubing color</div>
                        </div>
                    </div>
                </div>
            `;
            pairingCards.append(tubingCard);
        }

        if (allSelections['finish-ring']) {
            const color = getSelectionColor('ring');
            const ringCard = `
                <div class="pairing-card new-step">
                    <div class="main-text"><h2>Ring Color</h2></div>
                    <div class="main-box">
                        <div class="dot-text">
                            <strong style="color:${color.bg};">${getDisplayName(allSelections['finish-ring'], 'ring')}</strong>
                            <div class="desc">Your selected accent pieces</div>
                        </div>
                    </div>
                </div>
            `;
            pairingCards.append(ringCard);
        }

        if (allSelections['earpiece-color']) {
            const color = getSelectionColor('earpiece');
            const earpieceCard = `
                <div class="pairing-card new-step">
                    <div class="main-text"><h2>Ear Tips</h2></div>
                    <div class="main-box">
                        <div class="dot-text">
                            <strong style="color:${color.bg};">${getDisplayName(allSelections['earpiece-color'], 'earpiece')}</strong>
                            <div class="desc">Your selected ear tip color</div>
                        </div>
                    </div>
                </div>
            `;
            pairingCards.append(earpieceCard);
        }
        // const priceCard = `
        //     <div class="pairing-card new-step" style="border: 2px solid #EC9526; background: #FFF8F0;">
        //         <div class="main-text"><h2>Total Investment</h2></div>
        //         <div class="main-box">
        //             <div class="dot-text">
        //                 <strong style="color:#EC9526; font-size: 18px;"><span style="text-decoration: line-through;font-size:16px;margin-right:5px;">$59</span>$${totalPrice}</strong>
        //                 <div class="desc">Complete customization package</div>
        //             </div>
        //         </div>
        //     </div>
        // `;
        // pairingCards.append(priceCard);

        let hasCoreSelection = false;
            $('.step').each(function() {
                if ($(this).find('.core-tab input[type="radio"]:checked').length > 0) {
                    hasCoreSelection = true;
                }
            });

            // Real sum bought separately: tubing ($29 Black / $39 color) + ring set $19 + ear tip set $9 (catalog 2026-11-03)
            const tubingKey = getDisplayName(allSelections['finish-pipe'], 'pipe').trim().toLowerCase();
            const originalPrice = hasCoreSelection ? 69 : (tubingKey === 'black' ? 57 : 67);
            const discountedPrice = hasCoreSelection ? 59 : 49;

            const priceCard = `
                <div class="pairing-card new-step" style="border: 2px solid #EC9526; background: #FFF8F0;">
                    <div class="main-text"><h2>Complete Package</h2></div>
                    <div class="main-box">
                        <div class="dot-text">
                            <strong style="color:#EC9526; font-size: 18px;">$${discountedPrice}</strong>
                            <div class="desc">Build separately: <span style="text-decoration: line-through;">$${originalPrice}</span></div>
                        </div>
                    </div>
                </div>
            `;
            pairingCards.append(priceCard);

            if (!hasCoreSelection) {
                const bonusRow = `
                    <div class="lab-bonus-row new-step">
                        <img src="https://cdn.shopify.com/s/files/1/0525/8323/5780/files/hf_20260712_050035_7c21bc7d-821f-4485-ba1a-429054567b81.png?v=1783832550&width=180" alt="White AirTag holder" loading="lazy">
                        <div>
                            <strong>Free White AirTag Holder included</strong> <span class="lab-bonus-value">($14 value)</span>
                            <div class="lab-bonus-sub">Clip in your own AirTag so your stethoscope never walks off. AirTag not included.</div>
                        </div>
                    </div>
                `;
                pairingCards.append(bonusRow);
            }

        console.log('Final step display updated with total price:', totalPrice);
    }

    $('#submit-btn').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const buttonText = $(this).text().trim();
        
        if (buttonText === 'Pre-Order') {
            console.log('🎯 Pre-Order clicked - Opening modal');
            openPreOrderModal();
        } else {
            console.log('🛒 Checkout clicked - Proceeding to cart');
            const checkoutData = {
                selections: allSelections,
                totalPrice: totalPrice,
                stepPrices: selectedStepPrices
            };
            proceedToCheckout(checkoutData);
        }
    });

    $('#next-btn').on('click', function(e) {
        checkRadioSelection();
        if ($(this).prop('disabled')) {
            e.preventDefault();
            return;
        }
        if (currentStep < 5) {
            updateStep(currentStep + 1);
        }
    });

    $('#prev-btn').on('click', function() {
        if (currentStep > 1) {
            updateStep(currentStep - 1);
        }
    });

    $('#step-1 .finish-radio').on('change', function() {
        checkRadioSelection();
        addStepPrice(currentStep);
        updateSubmitButtonText();
        updateFinishNameText();

        const selectedLabel = $(this).closest('.finish-btn');
        step1SelectedIndex = parseInt(selectedLabel.data('index'));
        const imageUrl = selectedLabel.data('image');

        [2, 3, 4].forEach(step => {
            if (selectedOptions[step]) {
                delete selectedOptions[step];
                delete selectedStepPrices[step];
                $(`#step-${step} .finish-radio`).prop('checked', false);
            }
        });
        step2SelectedIndex = 0;
        step3SelectedIndex = 0;
        allSelections = $.extend({}, allSelections, selectedOptions[currentStep]);
        updatePricing();
        console.log('🧹 Cleared all future steps');

        if (imageUrl) {
            changeStethoscopeImage(imageUrl);
        }
    });

    $('#step-2 .finish-radio').on('change', function() {
        checkRadioSelection();
        addStepPrice(currentStep);
        updateSubmitButtonText();

        const selectedLabel = $(this).closest('.finish-btn');
        const imagesArray = selectedLabel.data('images');
        
        const $activeTabContent = $(this).closest('.tab-pane');
        step2SelectedIndex = $activeTabContent.find('.finish-radio').index(this);

        sessionStorage.setItem('selectedPipeStyle', selectedTab);
        
        console.log('✅ Step 2 pipe selected, index:', step2SelectedIndex);
        console.log('✅ Active tab:', selectedTab);

        if (selectedOptions[3]) {
            delete selectedOptions[3];
            delete selectedStepPrices[3];
            $('#step-3 .finish-radio').prop('checked', false);
            step3SelectedIndex = 0;
            console.log('🧹 Cleared Step 3 selection');
        }
        if (selectedOptions[4]) {
            delete selectedOptions[4];
            delete selectedStepPrices[4];
            $('#step-4 .finish-radio').prop('checked', false);
            console.log('🧹 Cleared Step 4 selection');
        }
        
        allSelections = $.extend({}, allSelections, selectedOptions[currentStep]);
        updatePricing();

        if (imagesArray && imagesArray[step1SelectedIndex]) {
            const matchedImageUrl = imagesArray[step1SelectedIndex];
            changeStethoscopeImage(matchedImageUrl);
        }
    });

    $('#step-3 .finish-radio').on('change', function() {
        checkRadioSelection();
        addStepPrice(currentStep);
        updateSubmitButtonText();

        const selectedLabel = $(this).closest('.finish-btn');
        const ringStyle = selectedLabel.attr('data-style') || 'classic';
        sessionStorage.setItem('selectedRingStyle', ringStyle);
        console.log('💍 Step 3 Ring Style saved:', ringStyle);

        let imagesArray;
        console.log('📍 Step 2 was:', selectedTab);
    
        if (selectedTab === 'Core') {
            imagesArray = selectedLabel.data('images-core');
            console.log('✅ Using CORE pipes images');
        } else {
            imagesArray = selectedLabel.data('images');
            console.log('✅ Using CLASSIC pipes images');
        }

        const $activeTabContent = $(this).closest('.tab-pane');
        step3SelectedIndex = $activeTabContent.find('.finish-radio').index(this);
 
        console.log('Debug:', {
            selectedTab: selectedTab,
            step1Index: step1SelectedIndex,
            step2Index: step2SelectedIndex,
            step3Index: step3SelectedIndex,
            hasImages: imagesArray ? 'Found' : 'Missing'
        });

        if (imagesArray && imagesArray[step2SelectedIndex] && imagesArray[step2SelectedIndex][step1SelectedIndex]) {
            const imageUrl = imagesArray[step2SelectedIndex][step1SelectedIndex];
            if (imageUrl) {
                changeStethoscopeImage(imageUrl);
                console.log('✅ Image changed to:', imageUrl);
            } else {
                console.error('❌ Image URL is empty!');
            }
        } else {
            console.error('❌ Image array path invalid!');
        }
    });

    $('#step-4 .finish-radio').on('change', function() {
        checkRadioSelection();
        addStepPrice(currentStep);
        updateSubmitButtonText();

        const selectedLabel = $(this).closest('.finish-btn');
        let imagesArray;
        
        const ringStyle = sessionStorage.getItem('selectedRingStyle') || 'classic';
        const pipeStyle = sessionStorage.getItem('selectedPipeStyle') || 'Classic';
        
        console.log('🔍 Step 4 Checking:', {
            'Step 3 Ring Style': ringStyle,
            'Step 2 Pipe Style': pipeStyle
        });
        
        let finalStyle = 'classic';
        
        if (ringStyle === 'core') {
            finalStyle = 'core';
            console.log('✅ Using CORE (from Step 3 Ring)');
        } else if (pipeStyle === 'Core') {
            finalStyle = 'core';
            console.log('✅ Using CORE (from Step 2 Pipe)');
        } else {
            console.log('✅ Using CLASSIC (default)');
        }
        
        if (ringStyle === 'core' && pipeStyle === 'Classic') {
            imagesArray = selectedLabel.data('images-step3-core-classic');
            console.log('✅ Using images-step-core-classic (Classic Pipe + Core Ring combo)');
        } else if (ringStyle === 'core') {
            imagesArray = selectedLabel.data('images-step-3-core');
            console.log('Using images-step-3-core (Step 3 Core Ring)');
        } else if (finalStyle === 'core') {
            imagesArray = selectedLabel.data('images-core');
        } else {
            imagesArray = selectedLabel.data('images');
        }

        console.log('📊 Step 4 Debug:', {
            finalStyle: finalStyle,
            step1Index: step1SelectedIndex,
            step2Index: step2SelectedIndex,
            step3Index: step3SelectedIndex,
            hasImages: imagesArray ? 'Found' : 'Missing'
        });

        if (imagesArray && 
            imagesArray[step3SelectedIndex] && 
            imagesArray[step3SelectedIndex][step2SelectedIndex] && 
            imagesArray[step3SelectedIndex][step2SelectedIndex][step1SelectedIndex]) {
            
            const imageUrl = imagesArray[step3SelectedIndex][step2SelectedIndex][step1SelectedIndex];
            
            if (imageUrl) {
                changeStethoscopeImage(imageUrl);
                console.log('✅ Step 4 Image changed to:', imageUrl);
            } else {
                console.error('❌ Step 4 Image URL is empty!');
            }
        } else {
            console.error('❌ Step 4 Image array path invalid!');
        }
    });

    $('.finish-radio').not('#step-1 .finish-radio, #step-2 .finish-radio, #step-3 .finish-radio, #step-4 .finish-radio').on('change', function() {
        checkRadioSelection();
        addStepPrice(currentStep);
        updateSubmitButtonText();
    });

    $('.nav-link').on('click', function() {
        setTimeout(updateSubmitButtonText, 100);
    });

    $('input[name="finish"]').on('change', function() {
        updateFinishNameText();
    });

    // Initialization
    $('#step-1 .finish-radio').first().prop('checked', true);
    const firstLabel = $('#step-1 .finish-radio').first().closest('.finish-btn');
    step1SelectedIndex = parseInt(firstLabel.data('index'));
    const firstImageUrl = firstLabel.data('image');
    if (firstImageUrl) {
        changeStethoscopeImage(firstImageUrl);
    }
    selectedOptions[1] = { 'finish': $('#step-1 .finish-radio').first().val() };
    allSelections = $.extend({}, allSelections, selectedOptions[1]);

    addStepPrice(1);
    updateStep(1);
    updateSubmitButtonText();
    updateFinishNameText();

    // ✅ MODAL SETUP
    const modal = document.querySelector('[data-core-modal]');
    if (modal) {
        const closeBtn = modal.querySelector('[data-core-modal-close]');
        const form = modal.querySelector('[data-core-email-form]');
        const formContainer = modal.querySelector('[data-core-modal-form-container]');
        const successMessage = modal.querySelector('[data-core-success-message]');
        const submitBtn = modal.querySelector('[data-core-submit-btn]');

        const closeModal = () => {
            modal.classList.remove('active');
            document.body.style.overflow = '';
        };

        if (closeBtn) {
            closeBtn.addEventListener('click', closeModal);
        }

        modal.addEventListener('click', (e) => {
            if (e.target === modal) closeModal();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                closeModal();
            }
        });

        if (form) {
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                
                const emailInput = form.querySelector('[data-core-email-input]');
                const email = emailInput.value.trim();
                
                if (!email) {
                    alert('Please enter a valid email address.');
                    return;
                }
                
                submitBtn.disabled = true;
                submitBtn.textContent = 'Submitting...';
                
                fetch('/contact', {
                    method: 'POST',
                    body: new FormData(form),
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                })
                .then(() => {
                    formContainer.style.display = 'none';
                    successMessage.classList.add('active');
                    
                    setTimeout(() => {
                        closeModal();
                        setTimeout(() => {
                            formContainer.style.display = 'block';
                            successMessage.classList.remove('active');
                            form.reset();
                            submitBtn.disabled = false;
                            submitBtn.textContent = 'Join Waitlist';
                        }, 300);
                    }, 2000);
                })
                .catch(() => {
                    formContainer.style.display = 'none';
                    successMessage.classList.add('active');
                    
                    setTimeout(() => {
                        closeModal();
                        setTimeout(() => {
                            formContainer.style.display = 'block';
                            successMessage.classList.remove('active');
                            form.reset();
                            submitBtn.disabled = false;
                            submitBtn.textContent = 'Join Waitlist';
                        }, 300);
                    }, 2000);
                });
            });
        }
    }
});

